import axios from '../axios'
//废钢评价表列表(价格表列表)
export const getPurEvaluationPage = (data) => {
  return axios({
    url: '/api/sys/pur/evaluation/getPurEvaluationPage',
    method: 'post',
    data
  })
}
//保存废钢评价表
export const savePurEvaluation = (data) => {
  return axios({
    url: '/api/sys/pur/evaluation/savePurEvaluation',
    method: 'post',
    data
  })
}
//修改废钢评价表
export const updatePurEvaluation = (data) => {
  return axios({
    url: '/api/sys/pur/evaluation/updatePurEvaluation',
    method: 'post',
    data
  })
}
//删除废钢评价表
export const deletePurEvaluations = (data) => {
  return axios({
    url: '/api/sys/pur/evaluation/deletePurEvaluations',
    method: 'post',
    data
  })
}
//废钢评价表提交
export const evaluationSubmit = (data) => {
  return axios({
    url: '/api/sys/pur/evaluation/submit',
    method: 'post',
    data
  })
}
//确认废钢评价表
export const auditPurEvaluations = (data) => {
  return axios({
    url: '/api/sys/pur/evaluation/auditPurEvaluations',
    method: 'post',
    data
  })
}
//反确认废钢评价表
export const unAuditPurEvaluations = (data) => {
  return axios({
    url: '/api/sys/pur/evaluation/unAuditPurEvaluations',
    method: 'post',
    data
  })
}
//采购确认废钢评价表
export const purAuditPurEvaluations = (data) => {
  return axios({
    url: '/api/sys/pur/evaluation/purAuditPurEvaluations',
    method: 'post',
    data
  })
}
//采购反确认废钢评价表
export const unPurAuditPurEvaluations = (data) => {
  return axios({
    url: '/api/sys/pur/evaluation/unPurAuditPurEvaluations',
    method: 'post',
    data
  })
}
//导出废钢评价表
export const exportPurEvaluations = (data) => {
  return axios({
    url: '/api/sys/pur/evaluation/exportPurEvaluations',
    method: 'post',
    data
  })
}
//获取当前最新的价格本
export const getExecutePurEvaluation = (data) => {
  return axios({
    url: '/api/sys/pur/evaluation/getExecutePurEvaluation',
    method: 'post',
    data
  })
}
//废钢评价明细表列表
export const getPurEvaluationDetailPage = (data) => {
  return axios({
    url: '/api/sys/pur/evaluation/detail/getPurEvaluationDetailPage',
    method: 'post',
    data
  })
}
//评铁明细表列表
export const getPurAccessDetailPage = (data) => {
  return axios({
    url: '/api/sys/pur/access/detail/getPurAccessDetailPage',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/moudules/Evaluation.js